<template>
  <div class="download-container">
    <!-- 顶部反诈提示 -->
    <div class="anti-fraud-banner">
      反诈提示：刷单兼职，冒充公检法，共享手机屏幕，裸聊敲诈，赌博等都是诈骗，请立即举报
    </div>

    <!-- 应用图标 (使用 SVG 模拟 Android 图标) -->
    <div class="app-icon-wrapper">
      <img src="../assets/img/apk_max.png" alt="Android" class="android-icon">
    </div>

    <!-- 应用名称 -->
    <h1 class="app-title">建造者.2.1.9.apk</h1>

    <!-- 应用元信息 -->
    <p class="app-meta">14 分钟前  Android/HyperOS</p>

    <!-- 底部下载卡片 -->
    <div class="download-card">
      <span class="file-size">大小：56.6 M</span>
      <a
        href="/apk/建造者.2.1.9.apk"
        class="download-btn"
        download
      >
        下载
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DownloadPage',
}
</script>

<style scoped>
.download-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif;
  padding: 20px;
  box-sizing: border-box;
}

/* 反诈提示 */
.anti-fraud-banner {
  background-color: #fef8e7;
  color: #8c6d36;
  font-size: 14px;
  line-height: 1.5;
  padding: 12px 16px;
  border-radius: 8px;
  text-align: center;
  width: 100%;
  max-width: 400px;
  margin-bottom: 32px;
}

/* 图标 */
.app-icon-wrapper {
  margin-bottom: 24px;
}
.android-icon {
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
}

/* 标题 */
.app-title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

/* 副标题/元数据 */
.app-meta {
  font-size: 14px;
  color: #999;
  margin: 0 0 32px 0;
}

/* 底部卡片 */
.download-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f5f7fa;
  padding: 12px 24px;
  border-radius: 50px;
  width: 100%;
  max-width: 340px;
}

.file-size {
  font-size: 16px;
  color: #333;
}

.download-btn {
  background-color: #40a9ff;
  color: white;
  text-decoration: none;
  padding: 8px 24px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: 500;
  transition: background-color 0.3s;
}

.download-btn:hover {
  background-color: #1890ff;
}
</style>